<template>

  <v-select
    :filterable="false"
    :options="options"
    @search="onSearch"
    :multiple="multiple"
    :placeholder="placeholder"
    v-model="selected">
      <template slot="no-options">
        Pesquisar registros.
      </template>
  </v-select>

</template>

<script>
export default {
  name: 'Select',
  props: {
    value: {
      type: [String, Array]
    },
    placeholder: {
      type: String
    },
    multiple: {
      type: Boolean
    },
    search: {
      type: Function
    }
  },
  data () {
    return {
      selected: [],
      options: []
    }
  },
  watch: {
    selected (val) {
      this.change(val)
    }
  },
  computed: {
    nValue () {
      return this.multiple && !this.value ? [] : this.value
    }
  },
  created () {
    if (this.value) {
      this.search(undefined, this.value).then(result => {
        this.selected = result
      })
    }
  },
  methods: {
    onSearch (search, loading) {
      if (search.length) {
        loading(true)
        this.search(escape(search), undefined).then(result => {
          this.options = result
          loading(false)
        })
      }
    },
    change (val) {
      const value = Array.isArray(val) ? val.map(v => v.value) : (val ? val.value : val)

      if (value !== this.value) {
        this.$emit('input', value)
      }
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/Fields/SelectAjax.vue